<template>
  <section class="scene">
    <div class="container">
      <a-typography-title :level="1">
        应用场景
      </a-typography-title>
      <a-row :gutter="[20,20]">
        <a-col v-for="(item,index) in expand.list"
               :xs="24" :md="12" :xl="8">
          <div class="item" :class="`i_${index+1}`">
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <a-typography-text>
              {{ item.text }}
            </a-typography-text>
            <a-typography-paragraph>
              <p v-for="v in item.list">
                {{ v }}
              </p>
            </a-typography-paragraph>
          </div>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'consult_scene',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: '业务稳定性维持',
            text: '提供以下技术方案的咨询服务，为企业业务稳定性保驾护航：',
            list: [
              '多云资源弹性伸缩',
              '服务单元化建设',
              '多地域容灾'
            ]
          },
          {
            title: '云上IT成本精简',
            text: '提供以下技术方案的咨询服务，帮助企业大幅降低算力成本：',
            list: [
              '规格压测',
              '流量压测',
              '在离线混部'
            ]
          },
          {
            title: '技术架构迭代转型',
            text: '提供以下技术方案的咨询服务，帮助企业快速实现技术架构升级：',
            list: [
              '可观测性建设',
              '容器化&K8s资源调度',
              'Serverless架构升级'
            ]
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/consult/';

.scene {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background-color: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.ant-row {
  margin: @margin 0 0;
}

.item {
  position: relative;
  padding: 20px 20px;
  background: @color_white;
  border-radius: 8px;
  .shadow(0 0 15px fade(@color_black, 10));
  
  .loop(@i) when (@i<=3) {
    &.i_@{i} {
      &::before {
        background-position: -100px*(-1+@i) 0px;
      }
    }
    .loop(@i+1);
  }
  .loop(1);
  
  &::before {
    content: '';
    display: block;
    width: 100px;
    height: 90px;
    margin: 0 auto;
    .bg('@{image}scene_icon.png', 300px, 90px);
  }
  
  h5.ant-typography {
    margin: @margin_mo 0 0;
    .font(center, @text_big, @color_12, @text_big, true);
  }
  
  span.ant-typography {
    display: block;
    margin: 10px 0 0;
    .font(justify, @text+@line, @color_13, @text);
  }
  
  div.ant-typography {
    min-height: 78px;
    margin: 10px 0 0;
    .font(justify, @text+@line, @color_12, @text);
    
    p {
      position: relative;
      max-width: 180px;
      padding-left: 15px;
      margin: 0 auto;
      
      &::before {
        content: '';
        display: block;
        .position(absolute, 12px, auto, auto, 0);
        width: 4px;
        height: 4px;
        background: @color_6;
        border-radius: 50%;
      }
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .scene {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    @scale: 0.5;
    padding: 20px;
    
    .loop(@i) when (@i<=3) {
      &.i_@{i} {
        &::before {
          background-position: -100px*(-1+@i)*@scale 0px;
        }
      }
      .loop(@i+1);
    }
    .loop(1);
    
    &::before {
      width: 100px*@scale;
      height: 90px*@scale;
      .bg('@{image}scene_icon.png', 300px*@scale, 90px*@scale);
    }
    
    h5.ant-typography {
      .font(center, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    span.ant-typography {
      .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
    }
    
    div.ant-typography {
      .font(justify, @text_mo+@line_mo, @color_12, @text_mo);
    }
  }
}
</style>